(function($){
    $(document).ready( function(){
        menu();
        mobileMenu();
        $('.slider').slick({
            dots: true
        });
        var faq = $('.faq');
        if( faq.length > 0 ){
            toggleFaq( faq );
        }
        agendaTags();
        searchFunc();
        skiplinks();
        agendaTitle();
    });

    $(window).on('scroll', function(){
        var scrollPos = $(window).scrollTop();
        if( scrollPos > 500 ){
            $('.to-top').removeClass('hidden')
        }else{
            $('.to-top').addClass('hidden');
        }
    });

    function menu(){
        $('.menu > .menu-item-has-children > a, .menu > .menu-item-has-children > .tax-label').on('click', function(e){
            e.preventDefault();
            $this = $(this).parent();
            $overlay = $('.overlay');
            $openClass = $this.hasClass('open');
            $('.menu > .menu-item-has-children').removeClass('open');
            $overlay.removeClass('open menu filter');
            if( !$openClass ){
                $this.addClass('open');
                $parent = $this.parent().parent();
                if( $parent.hasClass('filters-wrapper') ){
                    $overlay.addClass('open filter');
                }else{
                    $overlay.addClass('open menu');
                }
            }
        });

        $('.overlay').on('click', function(){
            $('.menu > .menu-item-has-children').removeClass('open');
            $('.overlay').removeClass('open menu filter');
        });
    }

    function mobileMenu(){
        $('.menu-item-has-children', '.mobile-nav').addClass('js-menu');
        $('.menu-item-has-children', '.mobile-nav').on('click', function(){
            $('.sub-menu-wrap', $(this)).first().toggleClass('hide');
        });
    }

    function toggleFaq( faq ) {
        faq.children( '.faq__card').each( function() {
            $this = $(this);
            $answer = $this.children('.faq__card__answer');
            $answer.css('height', $answer.outerHeight() + "px");
            $this.addClass('closed');
            $('.faq__card__header', $this).on('click', function(){
                $(this).parent().toggleClass('open closed');
            });
        });
    }

    function agendaTags(){
        $filterSubmit = $('.filter-submit input[type="submit"]');
        $filterSubmit.attr('disabled', 'disabled');
        $tags = $('.curTags');
        $('#mc-filter input:checked').each( function(){
            $this = $(this);
            $value  = $this.val();
            $label  = $this.parent().text();
            $tags.append( '<span class="tag agenda__tag" data-value="' + $value + '">' + $label + '</span>' );
        });
        if( $('#mc-filter input:checked').length > 0 ){
            $tags.append( '<span class="tag agenda__tag agenda__tag--all">Wis alle filters</span>' );
        }
        $('#mc-filter').on('change', function(){
            countFilters();
        });
        countFilters();
        // wait for tags to be created
        setTimeout( function(){
            $('.agenda__tag').on('click', function(){
                $this = $(this);
                if( $this.hasClass( 'agenda__tag--all' ) ){
                    $('#mc-filter input:checked:not(#mobile-filter)').prop( 'checked', false );
                    $('.agenda__tag').remove();
                }else {
                    $value = $this.data( 'value' );
                    $('input[value="' + $value + '"]').prop( 'checked', false );
                    $this.remove();
                }
                $filterSubmit.removeAttr('disabled');
                countFilters();
            });
        }, 300);
        $('#mc-filter input:not(#mobile-filter)').on('change',function(){
            $filterSubmit.removeAttr('disabled');
        });
    }

    function countFilters() {
        $('.filter').each( function(){
            $this = $(this);
            $count = $('input:checked', $this).length;
            if( $count > 0 ){
                $('.tax-label .amount', $this).html( '(' + $count + ')' );
            }else{
                $('.tax-label .amount', $this).html( '' );
            }
        });
        $count = $('input:checked', $('.filters-wrapper')).length;
        
        if( $count > 0 ){
            $('.filters-mobile__button .filter-count').html( '(' + $count + ')' );
        }else{
            $('.filters-mobile__button .filter-count').html( '' );
        }
    }

    function searchFunc() {
        $('.search-count .count').text( $('.card--search:visible').length )
        $('.search-filter input').each(function(){
            $this = $(this);
            $this.on('change', function(){
                $('.search-filter input').each(function(){
                    $thisVal = $(this).val();
                    if( $(this).is(":checked") ){
                        $('.posttype--' + $thisVal ).show();
                    }else{
                        $('.posttype--' + $thisVal ).hide();
                    }
                });
                $('.search-count .count').text( $('.card--search:visible').length );
                console.log( $('.card--search:visible').length );
            });
        });
    }

    function skiplinks() {
        $content = $('#skiplinks').html();
        $('.skiplinks__content').html( $content );

        $('a[href^="#"]').on('click', function(event) {
            event.preventDefault();
            var target = this.hash;
            $('html, body').animate({
                scrollTop: $(target).offset().top - 20
            }, 500);
        });
        
        $(window).on('load', function() {
            if (location.hash) {
                setTimeout(function() {
                    window.scrollTo(0, 0);
                    var target = location.hash;
                    $('html, body').animate({
                        scrollTop: $(target).offset().top
                    }, 500);
                }, 1);
            }
        });
    }

    function agendaTitle(){
        if( $('body').hasClass('post-type-archive-cpt_agenda') ){
            $firstH1 = $('h1').first();
            $agendaFilters = $('.agenda-filters');
            if( $(window).width() < 1040 ) {
                distance = $firstH1.offset().top + $firstH1.parent().outerHeight();
                $agendaFilters.css('top', distance + 'px');
            }else{
                $agendaFilters.css('top', '');
            }
            $(window).on('resize', function(){
                if( $(window).width() < 1040 ) {
                    distance = $firstH1.offset().top + $firstH1.parent().outerHeight();
                    $agendaFilters.css('top', distance + 'px');
                }else{
                    $agendaFilters.css('top', '');
                }
            })
        }
    }
    
})(jQuery);